<template>
    <a-row :gutter="[16, 16]">
        <a-col :xs="24" :sm="12" :lg="span">
            <div class="info-label">Prazo de entrega (dias)</div>
            <a-input-number
                v-if="editable"
                v-model="form.delivery_days"
                :min="0"
                :max="365"
                :precision="0"
                placeholder="Ex.: 3"
                style="width: 100%"
            />
            <div v-else class="info-value">{{ daysLabel }}</div>
        </a-col>
        <a-col :xs="24" :sm="12" :lg="span">
            <div class="info-label">Tipo de pagamento</div>
            <a-select
                v-if="editable"
                v-model="form.payment_term_id"
                :options="termOptions"
                :loading="loadingTerms"
                show-search
                :filter-option="filterOption"
                placeholder="Selecione"
                allow-clear
                style="width: 100%"
            />
            <div v-else class="info-value">{{ termLabel }}</div>
        </a-col>
        <a-col :xs="24" :sm="12" :lg="span">
            <div class="info-label">Valor mínimo (R$)</div>
            <a-input v-if="editable" :value="form.minimum_billing" placeholder="0,00" @input="form.minimum_billing = decimal($event.target.value)" />
            <div v-else class="info-value">{{ form.minimum_billing ? brl(toNumber(form.minimum_billing)) : "--" }}</div>
        </a-col>
        <a-col :xs="24" :lg="compact ? 24 : 6">
            <div class="info-label">Observações</div>
            <a-textarea v-if="editable" v-model="form.notes" :rows="2" :maxLength="400" placeholder="Ex.: Entregar pela manhã" />
            <div v-else class="info-value notes-value">{{ form.notes || "--" }}</div>
        </a-col>
    </a-row>
</template>

<script>
import visitFormat from "@/pages/visits/visit-format.mixin";
import QuotationService from "@/services/QuotationService";
import { toNumber } from "../delivery";

export default {
    name: "DeliveryFields",
    mixins: [visitFormat],
    props: {
        form: { type: Object, required: true },
        editable: { type: Boolean, default: false },
        compact: { type: Boolean, default: false },
    },
    data() {
        return {
            terms: [],
            loadingTerms: false,
        };
    },
    computed: {
        span() {
            return this.compact ? 12 : 6;
        },
        termOptions() {
            return this.terms.map((term) => ({ value: term.ttp_id, label: String(term.ttp_nome).trim() }));
        },
        termLabel() {
            const term = this.terms.find((item) => item.ttp_id === this.form.payment_term_id);
            return term ? String(term.ttp_nome).trim() : "--";
        },
        daysLabel() {
            const days = this.form.delivery_days;
            if (days === null || days === undefined || days === "") return "--";
            return Number(days) === 1 ? "1 dia" : `${days} dias`;
        },
    },
    created() {
        this.loadingTerms = true;
        new QuotationService()
            .list_payment_types()
            .then(({ data }) => {
                this.terms = (data && data.data) || [];
            })
            .catch((error) => this.notifyError(error, "Não foi possível carregar os tipos de pagamento."))
            .finally(() => {
                this.loadingTerms = false;
            });
    },
    methods: {
        toNumber,
        filterOption(input, option) {
            const text = option.componentOptions.children[0].text || "";
            return text.toLowerCase().includes(input.toLowerCase());
        },
        decimal(value) {
            let text = String(value || "").replace(/\./g, ",").replace(/[^\d,]/g, "");
            const comma = text.indexOf(",");
            if (comma !== -1) text = text.slice(0, comma + 1) + text.slice(comma + 1).replace(/,/g, "").slice(0, 2);
            return text;
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/pages/visits/_detail-page";

.notes-value {
    white-space: pre-line;
}
</style>
